<template>
    <a :href="wizardRoute" class="text-slate-600 hover:text-slate-400">
      <ve-progress :progress="percentage" :size="100">
        {{percentage}}%
      </ve-progress>
    </a>
</template>

<script>
    import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";

    export default {
        name: "WizardCompletionCircle",
        mixins: [SonicuCoreMixin],
        props: {
            percentage: 0
        },
        computed: {
            wizardRoute(){
                return this.company.buildCompanyRoute('wizard');
            }
        }
    }
</script>

<style>

</style>